import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  type DocumentReference,
  type SetOptions,
} from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { sanitizeForFirestore } from './firestoreSanitize';

export async function writeDoc<T extends Record<string, unknown>>(
  ref: DocumentReference,
  data: T,
  options?: SetOptions & { stage?: string },
): Promise<void> {
  const payload = sanitizeForFirestore(data);
  try {
    if (options?.stage) {
      const { stage: _stage, ...setOptions } = options;
      if (Object.keys(setOptions).length > 0) {
        await setDoc(ref, payload, setOptions);
      } else {
        await setDoc(ref, payload);
      }
    } else if (options) {
      await setDoc(ref, payload, options);
    } else {
      await setDoc(ref, payload);
    }
  } catch (error: any) {
    const hasUndefinedFields = JSON.stringify(data).includes('undefined');
    console.error(
      `[FIRESTORE WRITE FAILURE] ${JSON.stringify({
        operation: 'setDoc',
        documentPath: ref.path,
        stage: options?.stage || 'unknown',
        errorCode: error?.code,
        errorName: error?.name,
        hasUndefinedFields,
        retryable: error?.code === 'unavailable' || error?.code === 'deadline-exceeded',
      })}`,
    );
    throw error;
  }
}

export async function patchDoc<T extends Record<string, unknown>>(
  ref: DocumentReference,
  data: T,
): Promise<void> {
  await updateDoc(ref, sanitizeForFirestore(data));
}

export { doc, getDoc, db };
